<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-4">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">
            Destinations of Supplier:
            <span class="nostrong-title"> {{ operator.name }}</span>
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteManyBranches()"
            >
              <i class="flaticon-delete"></i>Delete
            </base-button>

            <base-button
              type="primary"
              v-if="canUserCreate"
              @click="
                $router.push(
                  `/destinations/destinations/new?operator=${$route.params.id}`
                )
              "
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Destination</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div
          class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
        ></div>

        <div
          class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center text-right"
        >
          <base-button
            type="outline-neutral"
            class="min-button mb-2"
            @click="viewCard"
          >
            <i class="flaticon-menu"></i>
            View Card
          </base-button>
          <base-dropdown
            menu-on-right
            class="nav-item"
            tag="li"
            title-tag="a"
            title-classes="btn min-button btn-outline-neutral  mb-2"
            title="Actions"
          >
            <base-button slot="title" type="none" class="p-0 min-button">
              <i class="flaticon-downloading-files"></i>
            </base-button>
            <div
              class="dropdown-item"
              @click="download(selectedRows)"
              v-if="selectedRows.length > 0"
            >
              Selected Records
            </div>
            <div class="dropdown-item" @click="download([])">All Records</div>
          </base-dropdown>
        </div>
      </div>

      <div>
        <pagination-block
          :pageCount="branchesByOperatorId.pages"
          :total="branchesByOperatorId.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="branchesByOperatorId.docs"
          :fields="fields"
          sort-by.sync="name"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == branches.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(name)="data">
            <router-link
              class="capitalize hide-data"
              :to="
                `/destinations/destination/${data.item._id}?operator=${$route.params.id}`
              "
              >{{ data.item.name }}
            </router-link>
          </template>

          <template #cell(supplier)="data">
            <span class="hide-data" v-if="data.item.supplier">{{
              data.item.supplier.businessDetails.name
            }}</span>
          </template>

          <template #cell(phone)="data">
            <span class="hide-data">{{ data.item.phone }}</span>
          </template>

          <template #cell(email)="data">
            <a
              class="hide-data"
              :href="
                `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.email}`
              "
              target="_blank"
              >{{ data.item.email }}</a
            >
          </template>

          <template #cell(address)="data">
            <span class="role-table">{{ data.item.country }}</span>
            <span class="hide-data">{{ data.item.address }}</span>
          </template>

          <template #cell(hours_advance_booking)="data">
            <span class="hide-data">{{ data.item.hours_advance_booking }}</span>
          </template>
          <template #cell(actions)="data">
            <el-tooltip content="Edit" placement="bottom">
              <router-link
                class="icon-action"
                :to="
                  `/destinations/destination/${data.item._id}?operator=${$route.params.id}`
                "
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip content="Coverage Areas" placement="bottom">
              <span
                class="icon-action text-new ml-2"
                @click="
                  $router.push(`/destination/${data.item._id}/coverage-areas`)
                "
              >
                <i class="flaticon-radar"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Rates" placement="bottom">
              <span
                class="icon-action text-warning ml-2"
                @click="$router.push(`/destination/${data.item._id}/rates`)"
              >
                <i class="flaticon-bold-list"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                v-if="canUserDelete"
                @click="deleteBranch(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="branchesByOperatorId.pages"
          :total="branchesByOperatorId.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { OperatorsAPI, BranchesAPI, ExportAPI } from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
export default {
  name: "DestinationsOperator",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      operator: {
        name: ""
      },
      searchQuery: "",
      query: "",
      searchStatus: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "phone",
          label: "Phone N°",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "200px" },
          class: "text-left"
        },

        {
          key: "address",
          label: "Address",
          sortable: true,
          thStyle: { minWidth: "180px" },
          class: "text-left"
        },

        {
          key: "hours_advance_booking",
          label: "Hrs. Advanced",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "90px" }
        }
      ],
      cardview: false,
      selected: [],
      operatorId: null,

      limit: 0
    };
  },

  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Suppliers",
        to: "/suppliers"
      },

      {
        text: "Destination of Suppliers",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.operatorId = this.$route.params.id;
    await this.getLimit();
    await this.getOperatorData(this.operatorId);
    this.getOperatorsOptions();
    this.limit = this.paginationLimit;
    this.get(true, this.operatorId, this.limit, this.currentPage);
  },
  methods: {
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.operatorId, this.limit, this.currentPage);
      }
    },
    async getOperatorData(operatorId) {
      try {
        let { data } = await OperatorsAPI.getOperatorById(
          operatorId,
          this.sesion.token
        );
        this.operator.name = data.name;
      } catch (error) {
        this.operator.name = "";
      }
    },
    preventPaginations(page) {
      this.get(true, this.operatorId, this.limit, page);
    },
    nextPaginations(page) {
      this.get(true, this.operatorId, this.limit, page);
    },
    changePage(page) {
      this.get(true, this.operatorId, this.limit, page);
    },
    async deleteBranch(branchId) {
      let { value } = await Swal.fire({
        title: "Delete Destination",
        text: "Are you sure do you want to delete this Destination?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteBranchById(branchId);
      }
    },
    async deleteBranchById(branchId) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteBranchById(
          branchId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.operatorId, this.limit, this.currentPage);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Error!. Could not delete the Destination"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "Error!. Could not delete the Destination");
      }
    },
    async deleteManyBranches() {
      let { value } = await Swal.fire({
        title: "Delete Destinations",
        text: "Are you sure do you want to delete the selected Destinations?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyBranchesById(this.selectedRows);
      }
    },
    async deleteManyBranchesById(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteManyBranchesById(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.operatorId, this.limit, this.currentPage);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destinations has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVBranches(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `branches-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async get(loader, operatorId, limit, page, query) {
      this.getBranchesByOperatorId({
        operatorId: operatorId,
        loader: loader,
        limit: limit,
        page: page
      });
    },
    isInSupplierModule(modules = []) {
      if (!(modules.indexOf("suppliers") > -1)) {
        this.setSupplierSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setSupplierSearchCriteria"
    ]),
    ...mapActions([
      "getBranchesByOperatorId",
      "getOperatorsOptions",
      "getLimit"
    ])
  },
  computed: {
    branches: function() {
      if (this.branchesByOperatorId.docs) {
        return this.branchesByOperatorId.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "branchesByOperatorId",
      "sesion",
      "userRole",
      "paginationLimit"
    ]),
    canUserDelete() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "CREATE");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInSupplierModule(to.meta.modules);
    next();
  }
};
</script>
